<div
  role="tablist"
  [class]="tabListClasses()"
>
  @for (item of tabs(); track $index) {
    <radio
      role="tab"
      tabindex="0"
      [class]="tabClasses($index === activeTab())"
      [attr.aria-selected]="$index === activeTab()"
      [attr.data-testid]="item.tabId() ? 'tab-' + item.tabId() : null"
      [class.hidden]="item.hidden()"
      (click)="onTabClick($index)"
      (keydown)="onTabKeydown($event, $index)"
    >
      <span class="tab-label">{{ item.label() }}</span>
      @if (item.iconMessage()) {
        <app-badge
          class="ml-1"
          intent="accent"
          [attr.data-testid]="'tab-badge-' + $index"
          [icon]="item.icon()"
          [label]="item.iconMessage()!.toString()"
        />
      }
      @if (hasNewTabButton()) {
        <button
          class="tab-close cursor-pointer"
          aria-label="Close tab"
          (click)="onCloseTab($event, $index)"
          (keydown)="onCloseTabKeydown($event, $index)"
        >
          <app-icon
            class="text-xs"
            [icon]="faClose"
          />
        </button>
      }
    </radio>
    @if ($index === activeTab()) {
      <ng-container [ngTemplateOutlet]="tabs()[$index].template()" />
    }
  }
  @if (hasNewTabButton()) {
    <button
      role="tab"
      class="tab tab-new h-7 w-7 rounded-tab"
      tabindex="0"
      aria-label="New tab"
      (click)="onNewTab($event)"
      (keydown)="onNewTabKeydown($event)"
    >
      <app-icon
        [dense]="true"
        [icon]="faPlus"
      />
    </button>
  }
</div>
<ng-template #tabContent>
  <ng-content />
</ng-template>
